// components/http/Actions/SeccionEventoAction.js
import HttpCliente from '../HttpCliente';

/**
 * GET method - Obtiene secciones de un evento específico
 */
export const getSeccionesByEvento = (eventoId, setSecciones, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/SeccionEvento/evento/${eventoId}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSecciones(response.data.data || []);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al obtener secciones";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * POST method - Crea una nueva sección
 */
export const createSeccionEvento = (seccionData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.post("/SeccionEvento", seccionData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 201 || response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al crear la sección";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PUT method - Actualiza una sección existente
 */
export const updateSeccionEvento = (id, seccionData, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.put(`/SeccionEvento/${id}`, seccionData, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'Content-Type': 'application/json',
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al actualizar la sección";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * DELETE method - Elimina una sección
 */
export const deleteSeccionEvento = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.delete(`/SeccionEvento/${id}`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al eliminar la sección";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * PATCH method - Toggle status de una sección
 */
export const toggleSeccionEventoStatus = (id, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.patch(`/SeccionEvento/${id}/toggle-status`, {}, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al cambiar estado de la sección";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};

/**
 * GET method - Obtiene TODAS las secciones de un evento (incluidas deshabilitadas) para administración
 */
export const getAllSeccionesByEventoForAdmin = (eventoId, setSecciones, setError, token) => {
    return new Promise((resolve, reject) => {
        HttpCliente.get(`/SeccionEvento/evento/${eventoId}/admin`, {
            headers: {
                "Authorization": `Bearer ${token}`,
                'accept': '*/*'
            }
        })
        .then(response => {
            if (response.status === 200) {
                setSecciones(response.data.data || []);
                resolve(response.data);
            } else {
                setError(response.data.message);
                reject(response.data.message);
            }
        })
        .catch(error => {
            const errorMessage = error.response?.data?.message || "Error al obtener secciones";
            setError(errorMessage);
            reject(errorMessage);
        });
    });
};